export type User = {
  id: string;
  emailVerified?: boolean;
  email?: string;
  name?: string;
  username?: string;
  bio?: string;
  team?: Team;
  country?: string;
  birthday?: string;
  image?: string | null;
  background?: string | null;
  score?: number;
  verifiedAs?: VerificationRole;
  token?: string;
  usernameColor?: string;
  followers?: number;
  followings?: number;
  totalLikes?: number;
  showsHosted?: number;
  showsVisited?: number;
  debatesWon?: number;
  followingStatus?: string;
};

export type Team = {
  id: number;
  name: string;
};

export const enum AvatarSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const enum VerificationRole {
  User = 'user',
  Pro = 'professional',
}

export enum ProfileTab {
  RecordedShows = 'Recorded Shows',
  Channels = 'Channels',
}

export type LoginState = {
  email: string;
  password: string;
};

export type SignUpState = {
  email: string;
  password: string;
  confirmPassword: string;
  agreeWithTS?: boolean;
};

export type SetPasswordState = {
  password: string;
  code: string;
};
